import React from "react"
import { SpecificationListItem } from "containers"
import PropTypes from "prop-types"
import { AccordionText } from "AtomicContainers";

const AccessoriesCategory = ({ accessories, gtmEvents }) => {
  // Group accessories by category
  const groupedCategories = accessories.reduce((cats, accessory) => {
    cats[accessory.category] = cats[accessory.category] || []
    cats[accessory.category].push({ key: accessory.description })
    return cats
  }, {})
  // Convert it to array of category strings, sort it alphabetically
  const sortedCategories = Object.keys(groupedCategories).sort()
  if (sortedCategories.indexOf("Other") > -1) {
    // If there's 'Other' category out and put it at the end of array
    sortedCategories.push(sortedCategories.splice(sortedCategories.indexOf("Other"), 1)[0])
  }
  return (
    <AccordionText
      styleName='box'
      textAlign={"left"}
      title={`Fitted Accessories (${accessories.length})`}
      gtmEvents={gtmEvents}>
      {sortedCategories.map((category, index) => (
        <SpecificationListItem key={index} name={category} items={groupedCategories[category]} />
      ))}
    </AccordionText>
  )
}

AccessoriesCategory.propTypes = {
  accessories: PropTypes.array,
  gtmEvents: PropTypes.shape({
    collapse: PropTypes.array,
    expand: PropTypes.array
  })
}

export default AccessoriesCategory



// WEBPACK FOOTER //
// ./src/containers/outlet-store-detail/accessories-category.jsx